import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

const caseGallery = () =>
{
    const lightbox = GLightbox({
        selector: '[data-gallery="case"]',
        touchNavigation: true,
        loop: true,
        zoomable: true,
    });

    const btn = document.querySelector('.js-open_gallery');
    if (!btn) return;

    btn.addEventListener('click', () => {
        document.querySelectorAll('.pg-case-detail-data__image.is-hidden')
            .forEach(el => el.classList.remove('is-hidden'));
        btn.remove(); // ボタンを消す
    });
}

export default caseGallery;
